<template>
  <div class="page-container" id="app">
    <a-layout>

      <a-layout-sider v-if="this.token && (windowWidth > 800)" width="300" style="background: #fff"
                      :trigger="null"
                      collapsible
                      v-model="collapsed">
        <div style="text-align: center; margin-bottom: 10px">Logged in as {{loggedInName}}</div>
        <div v-if="business && business.logo">
          <img :src="api_url + business.logo"/>
        </div>
        <div class="logo" v-else/>
        <div style="text-align: center;font-weight: 900;margin: 20px 0">{{business.name}}</div>

        <!--<span>{{user.business.name}}</span>-->
        <a-menu theme="light" mode="inline" :defaultSelectedKeys="['1']" v-if="isAdmin">
          <a-menu-item key="1" @click="navigate('Dashboard')">
            <a-icon type="area-chart"/>
            <span>Dashboard</span>
          </a-menu-item>
          <a-menu-item key="2" @click="navigate('Loyalty')">
            <a-icon type="smile" />
            <span>Loyalty</span>
          </a-menu-item>
          <a-menu-item key="3" @click="navigate('Customers')">
            <a-icon type="user" />
            <span>Customers</span>
          </a-menu-item>
          <a-menu-item key="4" @click="navigate('Settings')">
            <a-icon type="setting" />
            <span>Settings</span>
          </a-menu-item>
          <a-menu-item key="5" @click="navigate('Staff')">
            <a-icon type="team" />
            <span>Staff</span>
          </a-menu-item>
        </a-menu>
        <a-menu theme="light" mode="inline" :defaultSelectedKeys="['1']" v-else>
          <a-menu-item key="1" @click="navigate('Dashboard')">
            <a-icon type="area-chart"/>
            <span>Dashboard</span>
          </a-menu-item>
          <a-menu-item key="3" @click="navigate('Customers')">
            <a-icon type="user" />
            <span>Customers</span>
          </a-menu-item>
        </a-menu>

        <a-button class="logout-btn" type="primary" @click="logout">Log out</a-button>
      </a-layout-sider>
      <a-drawer
        title="Yesloyal"
        placement="left"
        :closable="false"
        @close="onClose"
        :visible="visible"
      >
        <div v-if="business && business.logo">
          <img :src="api_url + business.logo"/>
        </div>
        <div class="logo" v-else/>

        <!--<span>{{user.business.name}}</span>-->
        <a-menu theme="light" mode="inline" :defaultSelectedKeys="['1']">
          <a-menu-item key="1" @click="navigate('Dashboard')">
            <span>Dashboard</span>
          </a-menu-item>
          <a-menu-item key="2" @click="navigate('Loyalty')">
            <span>Loyalty</span>
          </a-menu-item>
          <a-menu-item key="3" @click="navigate('Customers')">
            <span>Customers</span>
          </a-menu-item>
          <a-menu-item key="4" @click="navigate('Settings')">
            <span>Settings</span>
          </a-menu-item>
          <a-menu-item key="5" @click="navigate('Staff')">
            <span>Staff</span>
          </a-menu-item>
          <a-button class="logout-btn" type="primary" @click="logout">Log out</a-button>
        </a-menu>
      </a-drawer>

      <a-layout style="background: #FFF">
        <a-layout-header style="background: #fff; padding: 0;">
          <a-icon
            class="trigger"
            :type="collapsed ? 'menu-unfold' : 'menu-fold'"
            @click="showDrawer"
            v-if="this.token && (windowWidth < 800)"
          />
        </a-layout-header>
        <a-layout-content :style="{ margin: '24px 16px', padding: '', background: '#fff', minHeight: '280px' }">
          <router-view :title="title"/>
        </a-layout-content>
      </a-layout>

    </a-layout>
  </div>
</template>

<script>

import Vue from 'vue'

import { mapState } from 'vuex'
import VeeValidate from 'vee-validate'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import { get } from 'lodash'
import VueMask from 'v-mask'
import { API_URL } from './constants'

Vue.config.productionTip = false

Vue.use(Antd)
Vue.use(VeeValidate)
Vue.use(VueMask)

export default {
  name: 'app',
  data () {
    return {
      title: 'Account Search',
      collapsed: false,
      windowWidth: window.innerWidth,
      visible: false,
      api_url: API_URL,
    }
  },
  mounted () {
    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }
    this.$store.dispatch('business/getSettingsData')
  },
  watch: {
    token (newToken) {
      if (newToken) {
        this.$store.dispatch('business/getSettingsData')
      }
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/logout')
    },
    navigate (name) {
      this.$router.push({ name })
      if (this.windowWidth < 880) {
        this.visible = false
      }
    },
    showDrawer () {
      this.visible = true
    },
    onClose () {
      this.visible = false
    },
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      loggedInName: state => get(state.auth, 'agent.name') || get(state.auth, 'agent.email') || get(state.auth, 'user.name') || get(state.auth, 'user.email'),
      business: state => state.business.business,
      isAdmin: state => !state.auth.agent || (state.auth.agent.roles && state.auth.agent.roles[0] === 'admin'),
    }),
  },
}

</script>
<style lang="scss">
  @import "./assets/styles";
  body {
    &:after {
      content: '';
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      opacity: .3;
      z-index: -1;
    }
  }
  .ant-layout{
    padding: 24px;
    background: #fff;
  }
  .ant-layout-content{
    padding: 24px;
  }
  .logo {
    margin: 16px auto;
    max-height: 15vh;
    height: 180px;
    max-width: 180px;
    width: 100%;
    border-radius: 15px;
    background: rgba(25,25,25,.2);
  }
  .needColumn .ant-card-body input{
    width: 50%;
  }
  .myMap{
    flex: 0.4;
    justify-content: center;
    text-align: center;
  }
  .containMap{
    display: flex;justify-content: space-between;align-items: center;
  }
  .formAccountChange {
    display: grid; grid-template-columns: 1fr 1fr 1fr;justify-content: flex-end;align-items: flex-end;
  }

  @media screen and (min-width: 800px){
    .ant-layout-header {
      display: none;
    }
  }

  @media screen and (max-width: 800px) {
    .ant-layout {
      padding: 0;
    }
    .formAccountChange{
      display: inline;
    }
    .ant-layout-content{
      padding: 0;
    }
    .ant-row{
      flex-direction: column;
    }
    .needColumn .ant-card-body{
      display: flex;
      flex-flow: column;
    }
    .needColumn .ant-card-body input{
      width: 100%;
      flex-flow: column;
    }
    .myMap{
      flex: 1;    width: 100%;
      margin: 20px 0;
    }
    .myMap .ant-card-body{
      padding: 0;
    }
    .containMap{
      flex-flow: column;
    }
    .timeRow{
      margin: 10px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue